/*
 * MarketoOverridesVM - provides some custom methods to remove inline styles in
 * Marketo sourced forms
 * Based on marketoOverrides.coffee script
 */
function MarketoOverridesVM() {
  var self;
  self = this;
  self.root = void 0;
  self.form = void 0;
  self.findForm = function () {
    return (self.form = self.root.find("form.mktoForm"));
  };
  self.removeButtonWrap = function () {
    var buttonWrap;
    buttonWrap = self.root.find(".mktoButtonWrap");
    return buttonWrap.removeAttr("style");
  };
  self.useBootstrapDatepicker = function (elem) {
    if (!self.form) {
      self.findForm();
    }
    return self.form.find(elem).pickadate({
      autoclose: true,
      format: "dd/mm/yyyy",
      formatSubmit: "yyyy-mm-dd",
      selectYears: true,
      selectMonths: true,
      min: -30,
      max: 365,
    });
  };
  self.hideForms = function () {
    return self.root.append(
      $('<style id="mktohide">.mktoForm { display: none !important;}</style>')
    );
  };
  self.showForms = function () {
    return self.root.find("#mktohide").remove();
  };
  self.nukeBaseStyle = function () {
    self.form.removeAttr("style");
    self.form.children("style").remove();
    self.form.find(".mktoField").removeAttr("style");
    return $("#mktoForms2BaseStyle,#mktoForms2ThemeStyle").remove();
  };
  self.applyBindings = function (elem) {
    self.root = elem;
    return self.hideForms();
  };
}
window.MarketoOverridesVM = MarketoOverridesVM;
